import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cv_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("cv_cart", JSON.stringify(items));
  }, [items]);

  const add = (project, tons = 10) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.project_id === project.id);
      if (existing) {
        return prev.map((i) => i.project_id === project.id ? { ...i, tons: i.tons + tons } : i);
      }
      return [...prev, {
        project_id: project.id,
        name: project.name,
        image_url: project.image_url,
        price_per_ton: project.price_per_ton,
        available_tons: project.available_tons,
        category: project.category,
        tons,
      }];
    });
  };

  const update = (project_id, tons) => {
    setItems((prev) => prev.map((i) => i.project_id === project_id ? { ...i, tons: Math.max(1, Number(tons) || 1) } : i));
  };

  const remove = (project_id) => {
    setItems((prev) => prev.filter((i) => i.project_id !== project_id));
  };

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.tons, 0);
  const usdTotal = items.reduce((s, i) => s + i.tons * i.price_per_ton, 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, count, usdTotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
